import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Loader extends React.PureComponent {
  render() {
    const { className = '' } = this.props;

    return <div className={cx(styles.loader, className)} />;
  }
}



// WEBPACK FOOTER //
// ./app/components/loader/index.js